import request from '../tools/request'
import { HTTP } from './http'

const { GET } = request

// 必传资质清单查询入参（物料编码 + 四级类目主键ID + 资质场景 + 货主）
export interface QualificationConfigParam {
  materialCode?: string // 物料编码
  cateMdmId: string // 四级类目主键 ID（与新增/修改物料用的类目 ID 同源）
  scene?: string // 资质场景：SRM_SECOND_ADD(新增) / SRM_UPDATE(修改)
  ownerCode?: string // 货主：电商供应商物料默认 1000，供应商物料默认 1025
}

/**
 * 查必传资质清单（提交前预览）
 * 命中规则且场景匹配 → 返回必传资质 docType code 数组；否则返回空数组 []
 */
export const GET_QUALIFICATION_CONFIG_BY_MATERIAL = (
  params: QualificationConfigParam,
) => GET<string[]>(`${HTTP}/product/getRequiredQualDocTypes`, params)

// 按四级类目主键ID查询前台提示文案入参
export interface CategoryHintTextParam {
  cateMdmId: string // 四级类目主键 ID
}

// 统一响应结构（与 ResultBean 对齐）
interface ResultBean<T> {
  code: number
  msg: string | null
  data: T
}

/**
 * 按类目 ID 查询「前台提示文案」
 */
export const GET_CATEGORY_FRONTEND_HINT_TEXT = (params: {
  categoryId: string
}) => GET(`${HTTP}/product/getCategoryHintText`, params)
import request from '../tools/request'
import { HTTP } from './http'

const { GET } = request

// 必传资质清单查询入参（物料编码 + 四级类目主键ID + 资质场景 + 货主）
export interface QualificationConfigParam {
  materialCode?: string // 物料编码
  cateMdmId: string // 四级类目主键 ID（与新增/修改物料用的类目 ID 同源）
  scene?: string // 资质场景：SRM_SECOND_ADD(新增) / SRM_UPDATE(修改)
  ownerCode?: string // 货主：电商供应商物料默认 1000，供应商物料默认 1025
}

/**
 * 查必传资质清单（提交前预览）
 * 命中规则且场景匹配 → 返回必传资质 docType code 数组；否则返回空数组 []
 */
export const GET_QUALIFICATION_CONFIG_BY_MATERIAL = (
  params: QualificationConfigParam,
) => GET<string[]>(`${HTTP}/product/getRequiredQualDocTypes`, params)

// 按四级类目主键ID查询前台提示文案入参
export interface CategoryHintTextParam {
  cateMdmId: string // 四级类目主键 ID
}

// 统一响应结构（与 ResultBean 对齐）
interface ResultBean<T> {
  code: number
  msg: string | null
  data: T
}

/**
 * 按类目 ID 查询「前台提示文案」
 */
export const GET_CATEGORY_FRONTEND_HINT_TEXT = (params: {
  categoryId: string
}) => GET(`${HTTP}/product/getCategoryHintText`, params)
